import React, { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { FinancialDocumentPurchaseOrderFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import {
  FinancialDocumentAssociationType,
  InvoiceForm,
} from 'modules/finance/components/Invoices/Detail/Content/Form/types'
import { FinancePurchaseOrderSelector } from 'modules/finance/components/selectors/FinancePurchaseOrderSelector'

interface PurchaseSelectorProps {
  form: FormikProps<InvoiceForm>
  readonly: boolean
  onClear: () => void
  selectedPurchaseOrderObject: FinancialDocumentPurchaseOrderFragment | undefined | null
}

const PurchaseOrderSelector: React.FC<PurchaseSelectorProps> = ({
  form,
  readonly,
  onClear,
  selectedPurchaseOrderObject,
}) => {
  const { navigation } = useNavigation()
  const { company } = useCurrentSession()

  const selectedId =
    form.values.associations?.[0]?.resource?.type == FinancialDocumentAssociationType.PurchaseOrder
      ? form.values.associations?.[0]?.resource?.id
      : undefined

  const [currentValue, setCurrentValue] = useState<FinancialDocumentPurchaseOrderFragment | null>(
    selectedPurchaseOrderObject || null
  )

  const handleChange = (value: FinancialDocumentPurchaseOrderFragment | null) => {
    if (value) {
      form.setFieldValue('associations', [
        {
          resource: { id: Number(value.id), type: 'purchaseorder' },
        },
      ])
    } else {
      onClear()
    }
    setCurrentValue(value)
  }

  return (
    <Box flexDirection="row" justifyContent="spaceBetween" gap="s16" alignItems="flexEnd">
      <FinancePurchaseOrderSelector
        value={currentValue}
        onChange={handleChange}
        disabled={readonly}
        companyId={company.id}
      />
      {selectedId && (
        <Box paddingBottom={'s6'}>
          <Button.Router
            aria-label={i18n.t('finance.invoices.detail.fields.router_label_purchase_order')}
            type="secondary"
            blankTarget
            to={navigation.procurement.purchaseOrders.detail.fullPath({
              id: selectedId,
            })}
            iconName="arrow-right"
          />
        </Box>
      )}
    </Box>
  )
}

export default PurchaseOrderSelector
